import { c as _c } from "react/compiler-runtime";
import { HEADER_CELL_BORDER_BOTTOM, PINNED_RIGHT_EDGE_LINE_STYLE } from '../../../../constants/borderStyles';
export type ActionHeaderCellProps = {
  actionColumnWidth: number;
  heightPx: number;
  /** Sticky top offset in px. 0 when no group header row is shown; GROUP_HEADER_ROW_HEIGHT when visible. */
  stickyTop: number;
};

/**
 * Empty sticky header cell for the action column.
 * Pinned right at offset 0, same z-index as pinned header cells.
 */
export function ActionHeaderCell(props) {
  const $ = _c(7);
  let t0;
  if ($[0] !== props.actionColumnWidth || $[1] !== props.heightPx || $[2] !== props.stickyTop) {
    t0 = {
      position: "sticky",
      top: props.stickyTop,
      right: 0,
      zIndex: "var(--z-content-loader)",
      width: props.actionColumnWidth,
      maxWidth: props.actionColumnWidth,
      height: props.heightPx,
      ...HEADER_CELL_BORDER_BOTTOM
    };
    $[0] = props.actionColumnWidth;
    $[1] = props.heightPx;
    $[2] = props.stickyTop;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span style={PINNED_RIGHT_EDGE_LINE_STYLE} />;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t0) {
    t2 = <th className="p-0 border-0 bg-gray-50" aria-hidden={true} style={t0}>{t1}</th>;
    $[5] = t0;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}